// Drop target that unschedules a task (clears date/time)
import { Box } from '@mui/material';
import { useDroppable } from '@dnd-kit/core';

export default function UnscheduleDropZone({ children, sx, ...rest }) {
  const { setNodeRef } = useDroppable({ id: 'unscheduled-tasks-list' });
  return (
    <Box ref={setNodeRef} sx={sx} {...rest}>
      {children}
    </Box>
  );
}
